import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { mergeEntity } from 'store/reducers/Merge/Merge'

export default function useMerge(route, method) {
  const dispatch = useDispatch()

  const merge = useCallback(
    entity => {
      return dispatch(mergeEntity(route, entity, method))
    },
    [route, method, dispatch]
  )

  return merge
}

useMerge.propTypes = {
  route: PropTypes.string.isRequired
}
